<div>

  <h2 class="content-block"><i class="fa-solid fa-file-invoice"></i>Vize Başvuru İşlemleri</h2>

  <div class="row mb-5">
    <div class="col-12 col-md-3">
      <div class="content-block">
        <app-card icon="payment.png" title="Ödenen" [count]="paymentCounts.paid"></app-card>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="content-block">
        <app-card icon="payment.png" title="Ödeme Bekleyen" [count]="paymentCounts.pending"></app-card>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="content-block">
        <app-card icon="payment.png" title="Havale Bekleyen" [count]="paymentCounts.transferAwaiting"></app-card>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="content-block">
        <app-card icon="payment.png" title="Reddedilen" [count]="paymentCounts.rejected"></app-card>
      </div>
    </div>
  </div>
  <div class="content">
    <div>
      

      <dx-data-grid
        style="margin-top: -50px;"
        #dataGrid1
        keyExpr="id"
        class="responsive-paddings"
        [dataSource]="dataSource"
        [focusedRowEnabled]="true"
        (onRowClick)="rowClick($event)"
        (onRowUpdating)="onRowUpdating($event)"
        [editing]="{ mode: 'row', allowUpdating: true }"
      >        
        <dxi-column type="buttons" width="110" [fixed]="true" [fixedPosition]="'left'">
          <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        </dxi-column>

        <dxi-column
          dataField="id"
          [caption]="'#'"
          [width]="75"
          [allowFiltering]="false"
          [allowEditing]="false"
          sortOrder="desc"
        >
        <!-- <div
        *dxTemplate="let cellInfo of 'rowNumberTemplate'"
        class="name-template"
      >
        <div>
          {{ getRowNumber(cellInfo.rowIndex) }}
        </div>
      </div> -->
        </dxi-column>
        <dxo-export [enabled]="false"></dxo-export>
        <dxi-column
        dataField="visaApplicationId"
        caption="Başvuru Numarası"
        [allowEditing]="false"
      ></dxi-column>
        <dxi-column
          dataField="visaApplicationDate"
          dataType="date"
          format="dd.MM.yyyy HH:mm"
          caption="İşlem Tarihi"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column dataField="visaStatus" caption="Vize Durumu" cellTemplate="visaStatusCellTemplate" [width]="175">
          <dxo-lookup
            [dataSource]="visaStatuses"
            valueExpr="id"
            displayExpr="name"
          ></dxo-lookup>
        
          <div *dxTemplate="let cellData of 'visaStatusCellTemplate'">
            <b> 
            <span [ngClass]="getVisaStatusClassByText(cellData.value)">
              {{ getVisaStatusLabel(cellData.value) }}
            </span></b>
          </div>
        </dxi-column>
        
        <dxi-column dataField="visaLevelName" caption="Vize Aciliyeti" dataType="string" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="visaPaymentStatus" caption="Ödeme Durumu" cellTemplate="cellTemplate" width="175">
          <dxo-lookup
            [dataSource]="paymentStatusLookup"
            valueExpr="value"
            displayExpr="text"
          ></dxo-lookup>
        
          <div *dxTemplate="let cellData of 'cellTemplate'">
            <b><span [ngClass]="getPaymentStatusClass(cellData.value)">
              {{ getPaymentStatusLabel(cellData.value) }}
            </span></b>
          </div>
        </dxi-column>

        <dxi-column  caption="Fatura Durumu" dataField="isInvoiceSended" width="175" cellTemplate="invoiceStatusCellTemplate" [allowEditing]="false">
         
          <div *dxTemplate="let cellData of 'invoiceStatusCellTemplate'">
            <b><span [ngClass]="getInvoiceStatusClass(cellData.value)">
              {{ getInvoiceStatusLabel(cellData.value) }}
            </span></b>
          </div>
        </dxi-column>
        
        <dxi-column dataField="customerFirstName" caption="Ad" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="customerLastName" caption="Soyad" [allowEditing]="false"></dxi-column>
        <dxi-column
          dataField="visaCountry"
          caption="Vize Ülkesi"
          [allowEditing]="false"
        >
        </dxi-column>
        <dxi-column dataField="customerNationalityNumber" caption="TC" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="customerPassportNumber" caption="Pasaport No" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="familyMembershipId" caption="Grup Id" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="applicationType" caption="Başvuru Türü" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="applicationCity" caption="Başvuru Şehri" [allowEditing]="false"></dxi-column>
      </dx-data-grid>
    </div>

    <application-detail-panel
      [selectedVisaApplication]="selectedVisaApplication"
      [(isOpened)]="popupVisible"
      (invoiceUpdated)="getPaymentCounts()"
    >
    </application-detail-panel>
  </div>
</div>
